<template>
	<header-block title="Archived Vouchers" :logicalBack="true" @logicalBack="handleBack()"></header-block>
	<div v-if="!groupedVouchers" class="mt-6">
		<div v-for="i in 6" :key="i" class="mb-2">
			<v-skeleton-loader
				type="list-item-avatar-two-line"
			></v-skeleton-loader>
		</div>
	</div>
	<div v-else-if="groupedVouchers && groupedVouchers.length != 0" class="usedVouchers">				
		<div>
			<GroupedVoucherList 
				:vouchers="groupedVouchers" 
				:formatter="formatter"
				@group-clicked="handleGroupVoucherClick"
				@voucher-clicked="handleVoucherClicked"
				:merchantId="selectedMerchantId"
			/>
		</div>
	</div>
	<div v-else-if="groupedVouchers && groupedVouchers.length == 0">
		<p class="centered">You have no archived vouchers.</p>
	</div>
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import GroupedVoucherList from './elements/GroupedVoucherList.vue';

export default {
	mixins: [Services],
	components: {
		HeaderBlock, GroupedVoucherList},
	data() {
		return {
			archivedVouchers: [],
			selectedMerchantId: null
		}
	},
	methods: {
		onLoad: async function() {
			this._getCustomer();
			this._getCustomerVouchersGroupedByMerchant(null, /* archived */ true);
		},
		handleBack() {
			if (!this.selectedMerchantId) {
				this.$router.back();
			}
			this._getCustomerVouchersGroupedByMerchant(null, /* archived */ true, /* useCache */ true);
			this.selectedMerchantId = null;
		},
		handleGroupVoucherClick(voucher) {
			this.selectedMerchantId = voucher.merchantId;
			this._getCustomerVouchers(() => {
				this.groupedVouchers = this.vouchers;
			}, this.selectedMerchantId, /* archived */ true, /* useCache */ true);
		},
		handleVoucherClicked(voucher) {
			this.$router.push('/MyVouchers/Merchants/' + voucher.id + '?archive=true');
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

</style>
